import React, { useEffect } from "react";
import SchoolInfoContent from "./SchoolProfileCollapse";
import { AppDispatch, RootState } from "../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import { getSchoolProfileDetails } from "../../../apis/actions/school.actions";

export const SchoolProfile = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { data: schoolProfileDetails } = useSelector(
    (state: RootState) => state?.school?.schoolProfileDetails
  );
  useEffect(() => {
    dispatch(getSchoolProfileDetails());
  }, [dispatch]);
  return (
    <div className="takaful--content-profile">
      <div className="takaful--content-edit-profile-info">
        <div className="takaful--content-profile-title">
          <h1 style={{ marginBottom: "4rem" }}> المعلومات الأساسية </h1>
        </div>
        <SchoolInfoContent infoArray={schoolProfileDetails} />
      </div>
    </div>
  );
};
